import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient singleton compartilhado. Fica num módulo próprio (e não no main.tsx)
 * para que o authStore possa limpá-lo em TODA troca de identidade — login, logout,
 * iniciar/encerrar impersonação. Sem isso, o cache do react-query (staleTime 30s)
 * serviria dados do dono anterior à sessão seguinte (ex.: TVs de outro tenant
 * aparecendo logo após impersonar). Isolamento multi-tenant depende disso no front.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
